var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconInboxLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconInbox",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1750.588 1750.119H169.412c-31.172 0-56.47-25.412-56.47-56.47V1398.08l210.183 126.155h1273.75l210.184-126.155v295.567c0 31.059-25.299 56.47-56.47 56.47ZM169.412 846.589h169.412v555.332L112.94 1266.39V903.06c0-31.058 25.299-56.47 56.47-56.47Zm282.353 564.706V168.941h1016.47v1242.354H451.765Zm1298.823-564.706c31.172 0 56.47 25.412 56.47 56.47v363.332l-225.882 135.53V846.589h169.412Zm0-112.941h-169.412V56H338.824v677.648H169.412C76.009 733.648 0 809.657 0 903.059v790.59c0 93.402 76.01 169.411 169.412 169.411h1581.176c93.403 0 169.412-76.01 169.412-169.412V903.06c0-93.402-76.01-169.411-169.412-169.411ZM621.176 488.904h564.706V375.963H621.176v112.94Zm0 677.647h564.706v-112.94H621.176v112.94Zm0-338.823h677.648V714.786H621.176v112.942Z",
      fillRule: "evenodd"
    })));
  }
}
IconInboxLine.glyphName = 'inbox';
IconInboxLine.variant = 'Line';
IconInboxLine.displayName = 'IconInboxLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconInboxLine.propTypes = {
  ...SVGIcon.propTypes
};
IconInboxLine.allowedProps = [...SVGIcon.allowedProps];
export default IconInboxLine;
export { IconInboxLine };